import { getEnumValue } from '@philips-emr/tws-utils';

import ComponentType from '../component-type';

import SimpleCatalog from './simple-catalog';

const _catalogs = Symbol('catalogs');

class TypedCatalog {

  [_catalogs] = new SimpleCatalog('');

  constructor() {
    Object.keys(ComponentType)
      .forEach(key => {
        const type = getEnumValue(ComponentType, key);
        this[_catalogs].set(type, new SimpleCatalog(type));
      });
  }

  /**
   * Retrieve the registry for a specific component type.
   * @param {ComponentType} type desired type.
   * @returns {SimpleCatalog}.
   */
  get(type: string): SimpleCatalog {
    return this[_catalogs].get(type);
  }

  has(type: string): boolean {
    return this[_catalogs].has(type);
  }

}

export default TypedCatalog;
